import Component from '@glimmer/component';

import { concat } from '@ember/helper';
import { service } from '@ember/service';

import CButton from 'rise-ui/components/c-button.gjs';
import CIcon from 'rise-ui/components/c-icon.gjs';
import Sticky from 'rise-ui/components/sticky.gjs';
import Download from 'rise-ui/components/time-series/output/all/download.gjs';
import ViewApiRequest from 'rise-ui/components/view-api-request.gjs';
import and from 'rise-ui/helpers/and.js';
import dateNow from 'rise-ui/helpers/date-now.js';
import minutes from 'rise-ui/helpers/minutes.js';
import not from 'rise-ui/helpers/not.js';
import timeSeriesDate from 'rise-ui/helpers/time-series-date.js';
import sticky from 'rise-ui/modifiers/sticky.js';

export default class TimeSeriesOutputAllComponent extends Component {
  @service('time-series/graph-results') graphResults;

  <template>
    {{#let
      (concat
        "RISE Time Series Query Package ("
        (timeSeriesDate (dateNow interval=(minutes 1))) ")"
      )
      as | queriedTitle |
    }}
    <div class="c-time-series-output__section">

      <Sticky @name="meta-all">
        <:left>
          {{#unless this.graphResults.isAllLoaded}}
            <CButton
              @type="primary"
              @disabled={{this.isAllLoaded}}
              @action={{this.graphResults.toggleAll}}
            >
              {{#if this.graphResults.isSomeError}}
                <CIcon @icon="graph-retry" />
                Retry Plotting All Outputs
              {{else if this.graphResults.isSomeLoading}}
                <CIcon @icon="graph-pause" />
                Pause Plotting All Outputs
              {{else if this.graphResults.isSomePaused}}
                <CIcon @icon="graph-play" />
                Continue Plotting All Outputs
              {{else}}
                <CIcon @icon="graph" />
                Plot All Outputs
              {{/if}}
            </CButton>
          {{/unless}}
          <Download @filename={{queriedTitle}} />
          <ViewApiRequest @all={{true}} @filename={{queriedTitle}} />
        </:left>
      </Sticky>

      <h4 class="c-item-title c-time-series-output__section-title">
        All Outputs
      </h4>
      <div class="c-time-series-output__section-description">
        Plot all selected time series or download all selected time series as CSV
        or JSON files.
      </div>
      <div class="c-time-series-output__section-actions">
        <div class="c-time-series-output__section-graph-plot-all" {{sticky activate="meta-all"}}>
          <CButton
            @type="primary"
            @disabled={{this.graphResults.isAllLoaded}}
            @action={{this.graphResults.toggleAll}}
          >
            {{#if (and this.graphResults.isAllLoaded (not this.graphResults.isNone))}}
              <CIcon @icon="graph-done" />
              Done Plotting All Outputs
            {{else if this.graphResults.isSomeError}}
              <CIcon @icon="graph-retry" />
              Retry Plotting All Outputs
            {{else if this.graphResults.isSomeLoading}}
              <CIcon @icon="graph-pause" />
              Pause Plotting All Outputs
            {{else if this.graphResults.isSomePaused}}
              <CIcon @icon="graph-play" />
              Continue Plotting All Outputs
            {{else}}
              <CIcon @icon="graph" />
              Plot All Outputs
            {{/if}}
          </CButton>
        </div>
        <div class="c-time-series-output__section-download-buttons-all">
          <Download @filename={{queriedTitle}} />
          <ViewApiRequest @all={{true}} @filename={{queriedTitle}} />
        </div>
      </div>
    </div>
    {{/let}}
  </template>
}
